import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Paper, CircularProgress, } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/authSlice';
export function LogoutPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(logout());
        const timer = setTimeout(() => {
            navigate('/login');
        }, 3000);
        return () => clearTimeout(timer);
    }, [dispatch, navigate]);
    return (_jsx(Container, Object.assign({ component: "main", maxWidth: "xs", sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            paddingTop: 8,
            paddingBottom: 8,
        } }, { children: _jsx(Box, Object.assign({ sx: { width: '400px', maxWidth: '100%' } }, { children: _jsxs(Paper, Object.assign({ elevation: 3, sx: { padding: 3 } }, { children: [_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", my: 4 }, { children: _jsx(CircularProgress, {}) })), _jsx(Typography, Object.assign({ variant: "h6", align: "center", gutterBottom: true }, { children: "You are being logged out." })), _jsx(Typography, Object.assign({ variant: "body1", align: "center" }, { children: "Please wait while we log you out and redirect you to the home page." }))] })) })) })));
}
